import React from 'react';
import { Carousel } from 'antd';
import './Carousel.less';

export type CarouselProps<ItemInterface = any> = {
  items?: Array<ItemInterface>;
  renderer?: (item: ItemInterface) => React.ElementType;

  onClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const TCarousel: React.FC<CarouselProps> = <ItemInterface extends unknown>({
  renderer,
  items,
  ...props
}) => {
  const settings = {
    // dots: false,
    // infinite: true,
    // speed: 500,
    // slidesToShow: 10,
    // slidesToScroll: 10,
  };

  return (
    <div className="carousel-container">
      <Carousel {...settings}>{items.map((item) => renderer(item))}</Carousel>
    </div>
  );
};

export default TCarousel;
